import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Jurisdictions', href: '#jurisdictions' },
  { label: 'Process', href: '#process' },
  { label: 'Sectors', href: '#sectors' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Micro-bar */}
      <div style={{ backgroundColor: '#060f1d', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-8">
          <span className="text-xs font-inter" style={{ color: '#6b7280' }}>
            DIFC & ADGM Licensed &bull; Debt Capital Markets Specialists
          </span>
          <span className="text-xs font-inter hidden sm:block" style={{ color: '#6b7280' }}>
            info@alcbond.com
          </span>
        </div>
      </div>

      {/* Main Nav */}
      <nav
        style={{
          backgroundColor: scrolled ? 'rgba(6,15,29,0.95)' : 'rgba(6,15,29,0.9)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          transition: 'background-color 300ms ease',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
          {/* Logo */}
          <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-3" data-testid="logo-link">
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: '#0f2240', border: '1px solid rgba(201,168,76,0.3)' }}
            >
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                <path d="M4 16V4L10 10L16 4V16" stroke="#c9a84c" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="font-playfair text-xl font-bold tracking-tight">
              <span className="text-white">ALC</span>
              <span style={{ color: '#c9a84c' }}>BOND</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden nav:flex items-center gap-8">
            {navLinks.map(link => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollTo(e, link.href)}
                className="text-sm font-inter font-medium"
                style={{ color: '#9ca3af', transition: 'color 200ms' }}
                onMouseEnter={(e) => e.target.style.color = '#c9a84c'}
                onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA + Hamburger */}
          <div className="flex items-center gap-4">
            <a
              href="#contact"
              onClick={(e) => scrollTo(e, '#contact')}
              className="hidden nav:inline-flex font-semibold text-sm px-5 py-2.5 rounded"
              style={{ backgroundColor: '#c9a84c', color: '#060f1d', transition: 'background-color 200ms' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#dfc26e'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#c9a84c'}
              data-testid="nav-cta-button"
            >
              Start Your Issuance
            </a>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="nav:hidden text-white p-2"
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className="nav:hidden overflow-hidden"
          style={{
            maxHeight: menuOpen ? '400px' : '0',
            transition: 'max-height 300ms ease',
            backgroundColor: '#060f1d',
            borderTop: menuOpen ? '1px solid rgba(255,255,255,0.1)' : 'none',
          }}
        >
          <div className="px-4 py-6 space-y-4">
            {navLinks.map(link => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollTo(e, link.href)}
                className="block font-inter"
                style={{ color: '#9ca3af' }}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => scrollTo(e, '#contact')}
              className="block font-semibold text-sm px-5 py-2.5 rounded text-center"
              style={{ backgroundColor: '#c9a84c', color: '#060f1d' }}
              data-testid="mobile-cta-button"
            >
              Start Your Issuance
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
